export const createReactName = (inputString="") => {
  return inputString.toLowerCase().split(" ").map((word, index) => {
    if (word.length > 0) {
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
    } else {
      return word; 
    }
    }).join(""); 
}

export const generateCardTemplate = ( functionName = '',  col='') => {
    let name 
    if( functionName.includes(' ') ) {
      name = createReactName(functionName)
    } else {
      name = functionName
    }

    const template = `
      import React from 'react'
      import { ${col} } from './${col}.js'
      export const ${name} = () => {
        const [date, setDate] = useState()
        const [station, setStation] = useState()
        
        return (
          <CardTable 
              columns={${col}}
              data={"Archivo data"}
              hasControl
              hasHeader
              icon={<"Aqui tu icono" />}
              title={"Aqui tu titulo"}
              titleBlock
              blockBtn
            />
        )
      }
    `

    return template
}






